(function () {
    if (window.__SS_DISABLE_GRID_CAROUSEL) return;
    if (window.__SS_GRID_CAROUSEL_LOADED) return;

    window.__SS_GRID_CAROUSEL_LOADED = true;

    var cache = {};
    var observerStarted = false;

    function ensureCarouselStyles() {
    if (document.getElementById('ss-grid-carousel-styles')) return;

    var el = document.createElement('style');
    el.id = 'ss-grid-carousel-styles';

    el.textContent =
        '.grid__item-image-wrapper.ss-ss-carousel .grid-product__link:after{' +
        'pointer-events:none !important;' +
        '}' +
        '.grid__item-image-wrapper.ss-ss-carousel .grid-product__image-mask{' +
        'position:relative;z-index:2;' +
        '}';

    document.head.appendChild(el);
    }

    function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];

    cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin'
    })
        .then(function (r) {
        return r.ok ? r.json() : { images: [] };
        })
        .catch(function () {
        return { images: [] };
        });

    return cache[handle];
    }

    function withWidth(url, w) {
    if (!url) return url;

    var clean = url.split('?')[0];

    return clean + '?width=' + w;
    }

    function preloadImages(images) {
    images.forEach(function (src) {
        var pre = new Image();
        pre.decoding = 'async';
        pre.src = withWidth(src, 720);
    });
    }

    function initColorSwatches(card) {
    if (!card || card.__ssColorSwatches) return;

    var container = card.querySelector('.grid-product__colors--variant024');
    if (!container) return;

    card.__ssColorSwatches = true;

    var swatches = container.querySelectorAll('.color-swatch');
    var moreLink = container.querySelector('.grid-product__colors-more');
    var mask = card.querySelector('.grid-product__image-mask');
    var img = mask ? mask.querySelector('img') : null;
    var colorImages = card.querySelectorAll('.grid-product__color-image');

    function goToProduct(url, e) {
        if (!url) return;
        e.preventDefault();
        e.stopPropagation();
        window.location.href = url;
    }

    if (moreLink) {
        var productUrl = moreLink.dataset.productUrl;

        moreLink.addEventListener('click', function (e) {
        goToProduct(productUrl, e);
        });

        moreLink.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        goToProduct(productUrl, e);
        });
    }

    function setActiveSwatch(swatch) {
        var id = swatch.dataset.variantId;
        var image = swatch.dataset.variantImage;

        swatches.forEach(function (el) {
        el.classList.remove('is-active');
        });

        colorImages.forEach(function (el) {
        el.classList.remove('is-active');
        });

        swatch.classList.add('is-active');

        if (!image) return;

        if (img) {
        img.removeAttribute('data-srcset');
        img.removeAttribute('data-src');
        img.removeAttribute('srcset');
        img.sizes = '';
        img.loading = 'eager';
        img.src = image;
        }

        if (id) {
        var imageEl = card.querySelector('.grid-product__color-image--' + id);
        if (imageEl) {
            imageEl.style.backgroundImage = 'url(' + image + ')';
            imageEl.classList.add('is-active');
        }
        }
    }

    swatches.forEach(function (swatch, index) {
        swatch.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        setActiveSwatch(swatch);
        });

        swatch.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        e.stopPropagation();
        setActiveSwatch(swatch);
        });

        if (index === 0) {
        swatch.classList.add('is-active');
        }
    });
    }

    function init(card) {
    if (!card) return;

    initColorSwatches(card);

    if (card.__ssCarousel) return;

    var handle = card.getAttribute('data-product-handle');
    if (!handle) return;

    var mask = card.querySelector('.grid-product__image-mask');
    if (!mask) return;

    var img = mask.querySelector('img');
    if (!img) return;

    card.__ssCarousel = true;

    fetchProduct(handle).then(function (data) {
        var images = data && data.images ? data.images.filter(Boolean) : [];

        if (images.length > 6) {
        images = images.slice(0, 6);
        }

        if (images.length < 2) return;

        build(card, mask, img, images);
    });
    }

    function build(card, mask, img, images) {
    if (mask.querySelector('.ss-carousel-arrow, .ss-carousel-dots')) return;

    var wrap = mask.closest('.grid__item-image-wrapper');
    var imageLink = mask.querySelector('a.grid-product__image-link');
    var productLink = imageLink || card.querySelector('a.grid-product__link');

    ensureCarouselStyles();

    if (wrap) {
        wrap.classList.add('ss-ss-carousel');
    }

    mask.classList.add('ss-carousel-active');
    mask.style.touchAction = 'pan-y';
    img.style.touchAction = 'pan-y';

    preloadImages(images);

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'ss-carousel-arrow ss-carousel-arrow--prev';
    prev.setAttribute('aria-label', 'Previous image');
    prev.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'ss-carousel-arrow ss-carousel-arrow--next';
    next.setAttribute('aria-label', 'Next image');
    next.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';

    var dots = document.createElement('div');
    dots.className = 'ss-carousel-dots';

    var current = 0;
    var suppressLinkClick = false;

    function go(i) {
        i = ((i % images.length) + images.length) % images.length;
        current = i;

        var src = images[i];

        img.removeAttribute('data-srcset');
        img.removeAttribute('data-src');
        img.removeAttribute('srcset');

        img.sizes = '';
        img.loading = 'eager';
        img.src = withWidth(src, 720);

        Array.prototype.forEach.call(dots.children, function (d, idx) {
        d.classList.toggle('is-active', idx === i);
        });
    }

    images.forEach(function (_, i) {
        var d = document.createElement('button');

        d.type = 'button';
        d.className = 'ss-carousel-dot' + (i === 0 ? ' is-active' : '');
        d.setAttribute('aria-label', 'Image ' + (i + 1));

        d.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        go(i);
        });

        dots.appendChild(d);
    });

    function stop(e) {
        e.preventDefault();
        e.stopPropagation();
    }

    prev.addEventListener('click', function (e) {
        stop(e);
        go(current - 1);
    });

    next.addEventListener('click', function (e) {
        stop(e);
        go(current + 1);
    });

    mask.appendChild(prev);
    mask.appendChild(next);
    mask.appendChild(dots);

    function shouldIgnoreImageNavigation(target) {
        return !!target.closest(
        '.quick-product__btn, .ss-carousel-arrow, .ss-carousel-dots, .ss-carousel-dot, .grid-product__selling-fast-badge'
        );
    }

    if (imageLink) {
        imageLink.addEventListener(
        'click',
        function (e) {
            if (shouldIgnoreImageNavigation(e.target)) {
            e.preventDefault();
            return;
            }

            if (suppressLinkClick) {
            e.preventDefault();
            }
        },
        true
        );
    } else {
        mask.addEventListener('click', function (e) {
        if (!productLink) return;

        if (shouldIgnoreImageNavigation(e.target)) {
            return;
        }

        if (!e.target.closest('img, .grid__image-ratio, .image-wrap')) {
            return;
        }

        if (suppressLinkClick) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }

        e.preventDefault();
        e.stopPropagation();

        if (productLink.href) {
            window.location.href = productLink.href;
        }
        });
    }

    var startX = null;
    var startY = null;
    var pointerId = null;

    function endSwipe(clientX, clientY, isCancel) {
        if (startX == null || isCancel) {
        startX = startY = pointerId = null;
        return;
        }

        var dx = clientX - startX;
        var dy = clientY - startY;

        if (Math.abs(dx) > 36 && Math.abs(dx) > Math.abs(dy) * 1.15) {
        suppressLinkClick = true;

        window.setTimeout(function () {
            suppressLinkClick = false;
        }, 450);

        if (dx < 0) {
            go(current + 1);
        } else {
            go(current - 1);
        }
        }

        startX = startY = pointerId = null;
    }

    if (window.PointerEvent) {
        mask.addEventListener(
        'pointerdown',
        function (e) {
            // Let native <a> handle mouse clicks (left + middle).
            if (e.pointerType === 'mouse') return;

            if (
            e.target.closest(
                '.quick-product__btn, .ss-carousel-arrow, .ss-carousel-dots, .ss-carousel-dot, .grid-product__selling-fast-badge'
            )
            ) {
            return;
            }

            pointerId = e.pointerId;
            startX = e.clientX;
            startY = e.clientY;
        },
        true
        );

        mask.addEventListener(
        'pointermove',
        function (e) {
            if (e.pointerType === 'mouse') return;
            if (pointerId !== e.pointerId || startX == null) return;

            var dx = e.clientX - startX;
            var dy = e.clientY - startY;

            if (Math.abs(dx) > 14 && Math.abs(dx) > Math.abs(dy) && e.cancelable) {
            e.preventDefault();
            }
        },
        { passive: false, capture: true }
        );

        mask.addEventListener(
        'pointerup',
        function (e) {
            if (e.pointerType === 'mouse') return;
            if (pointerId !== e.pointerId) return;

            endSwipe(e.clientX, e.clientY, false);
        },
        true
        );

        mask.addEventListener(
        'pointercancel',
        function (e) {
            if (e.pointerType === 'mouse') return;
            if (pointerId !== e.pointerId) return;

            startX = startY = pointerId = null;
        },
        true
        );
    } else {
        mask.addEventListener(
        'touchstart',
        function (e) {
            if (e.touches.length !== 1) {
            startX = null;
            return;
            }

            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
        },
        { passive: true, capture: true }
        );

        mask.addEventListener(
        'touchmove',
        function (e) {
            if (startX == null || e.touches.length !== 1) return;

            var dx = e.touches[0].clientX - startX;
            var dy = e.touches[0].clientY - startY;

            if (Math.abs(dx) > 14 && Math.abs(dx) > Math.abs(dy) && e.cancelable) {
            e.preventDefault();
            }
        },
        { passive: false, capture: true }
        );

        mask.addEventListener(
        'touchend',
        function (e) {
            if (startX == null) return;

            endSwipe(e.changedTouches[0].clientX, e.changedTouches[0].clientY, false);
        },
        { capture: true }
        );

        mask.addEventListener(
        'touchcancel',
        function () {
            startX = startY = null;
        },
        { capture: true }
        );
    }

    img.setAttribute('draggable', 'false');
    img.style.userSelect = 'none';
    img.style.webkitUserSelect = 'none';
    img.style.webkitTouchCallout = 'none';
    }

    function start(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = scope.querySelectorAll('.grid-product[data-product-handle]');

    if (!cards.length) return;

    if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
        function (entries) {
            entries.forEach(function (en) {
            if (en.isIntersecting) {
                init(en.target);
                io.unobserve(en.target);
            }
            });
        },
        { rootMargin: '200px 0px' }
        );

        cards.forEach(function (card) {
        if (!card.__ssCarousel) {
            io.observe(card);
        }
        });
    } else {
        cards.forEach(init);
    }
    }

    function observeCollectionChanges() {
    if (observerStarted || !window.MutationObserver) return;

    observerStarted = true;

    var target =
        document.querySelector('[data-section-type*="collection"]') ||
        document.querySelector('.collection-grid') ||
        document.querySelector('.grid') ||
        document.body;

    var observer = new MutationObserver(function (mutations) {
        var shouldRefresh = false;

        mutations.forEach(function (mutation) {
        if (mutation.addedNodes && mutation.addedNodes.length) {
            shouldRefresh = true;
        }
        });

        if (shouldRefresh) {
        window.requestAnimationFrame(function () {
            start(target);
        });
        }
    });

    observer.observe(target, {
        childList: true,
        subtree: true
    });
    }

    function boot() {
    start();
    observeCollectionChanges();
    }

    if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
    } else {
    boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
    start(e.target);
    });

    document.addEventListener('shopify:section:reorder', function () {
    start();
    });

    window.SSGridCarousel = {
    refresh: start
    };
})();
